import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDiamondTurnRight = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	id: "Layer_1",
	"data-name": "Layer 1",
	viewBox: "0 0 24 24",
	width: 512,
	height: 512,
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M22.543,8.481L15.519,1.457c-1.939-1.939-5.098-1.939-7.037,0L1.457,8.481c-1.939,1.94-1.939,5.097,0,7.037l7.024,7.024c.97,.97,2.244,1.454,3.519,1.454s2.549-.484,3.519-1.454l7.024-7.024c1.939-1.94,1.939-5.097,0-7.037Zm-1.414,5.623l-7.024,7.024c-1.16,1.158-3.049,1.158-4.209,0L2.871,14.104c-1.159-1.16-1.159-3.049,0-4.209L9.896,2.871c1.16-1.16,3.049-1.16,4.209,0l7.024,7.024c1.159,1.16,1.159,3.049,0,4.209Zm-4.001-5.226c1.17,1.17,1.17,3.072,0,4.242l-2.421,2.421c-.195,.195-.451,.293-.707,.293s-.512-.098-.707-.293c-.391-.391-.391-1.023,0-1.414l2.128-2.128h-4.421c-.552,0-1,.448-1,1v3c0,.553-.447,1-1,1s-1-.447-1-1v-3c0-1.654,1.346-3,3-3h4.421l-2.128-2.128c-.391-.391-.391-1.023,0-1.414s1.023-.391,1.414,0l2.421,2.421Z" })
});
export default SvgDiamondTurnRight;
